import { render, staticRenderFns } from "./Clinics.vue?vue&type=template&id=57f27935&scoped=true&"
import script from "./Clinics.vue?vue&type=script&lang=js&"
export * from "./Clinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f27935",
  null
  
)

export default component.exports